"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.TextWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Wrapper = exports.Wrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  font-family: var(--font-family);\n  font-size: var(--font-size-xxs);\n  color: var(--color-neutral-130);\n  align-items: center;\n  ", "\n"])), function (_ref) {
  var direction = _ref.direction;
  return direction === 'rtl' && 'flex-direction: row-reverse;';
});
var TextWrapper = exports.TextWrapper = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  margin: 0 var(--spacing-2);\n  ", "\n  min-width: ", ";\n"])), function (_ref2) {
  var imageSize = _ref2.imageSize;
  return imageSize === 'large' ? '72px' : '57px';
}, function (_ref3) {
  var direction = _ref3.direction;
  return direction === 'rtl' && 'align-items: flex-end;';
}, function (_ref4) {
  var imageSize = _ref4.imageSize;
  return imageSize === 'large' ? 'calc(100% - 88px)' : 'calc(100% - 73px)';
});